// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalViewMode_profile-view__KPgLe {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: "Sora", sans-serif;
}
.ProfessionalViewMode_profile-view__head__XALgF {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: start;
}
@media (max-width: 600px) {
  .ProfessionalViewMode_profile-view__head__XALgF {
    gap: 5px;
  }
}
.ProfessionalViewMode_profile-view__name__gkn3m {
  margin: 0;
  font-size: 44px;
  line-height: 0.98;
  letter-spacing: -0.04em;
  font-weight: 800;
  color: #13231D;
}
@media (max-width: 768px) {
  .ProfessionalViewMode_profile-view__name__gkn3m {
    font-size: 32px;
  }
}
.ProfessionalViewMode_profile-view__role__mpOD7 {
  margin: 10px 0 0;
  font-size: 21px;
  font-weight: 800;
  color: rgba(19, 35, 29, 0.68);
}
@media (max-width: 768px) {
  .ProfessionalViewMode_profile-view__role__mpOD7 {
    font-size: 18px;
  }
}
.ProfessionalViewMode_profile-view__share__tAJZX {
  font-size: 12px;
  color: #5F726B;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  cursor: pointer;
  padding-top: 8px;
}
.ProfessionalViewMode_profile-view__share__tAJZX:hover {
  color: #13231D;
}
.ProfessionalViewMode_profile-view__specialties__JaRW3 {
  margin-top: 18px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.ProfessionalViewMode_profile-view__label__q6qV8 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: rgba(19, 35, 29, 0.68);
}
.ProfessionalViewMode_profile-view__icon-tag__YH6dC {
  width: 20px;
  height: 20px;
  object-fit: contain;
  opacity: 0.72;
}
.ProfessionalViewMode_profile-view__chip-row__wfSC1 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.ProfessionalViewMode_profile-view__tag__fdcar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 11px;
  border-radius: 999px;
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: #F8F6F2;
  font-size: 11px;
  font-weight: 800;
}
.ProfessionalViewMode_profile-view__tag--cuerpo__wJppv {
  background: rgba(36, 46, 123, 0.1);
  color: #242E7B;
  border: 1px solid #242E7B;
}
.ProfessionalViewMode_profile-view__tag--conciencia__CJzxq {
  background: rgba(87, 64, 147, 0.1);
  color: #574093;
  border: 1px solid #574093;
}
.ProfessionalViewMode_profile-view__tag--mente__o246A {
  background: rgba(93, 138, 186, 0.12);
  color: #4F769F;
  border: 1px solid #4F769F;
}
.ProfessionalViewMode_profile-view__tag--energia__kj3F\\+ {
  background: rgba(83, 169, 110, 0.12);
  color: #3F8355;
  border: 1px solid #3F8355;
}
.ProfessionalViewMode_profile-view__meta-group__B-JXG {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ProfessionalViewMode_profile-view__meta-line__j1bgk {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 700;
}
.ProfessionalViewMode_profile-view__icon-check__wQnen {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  flex: 0 0 auto;
}
.ProfessionalViewMode_profile-view__icon-check__wQnen:before {
  content: "";
  position: absolute;
  left: 1px;
  top: 3px;
  width: 5px;
  height: 9px;
  border-right: 3px solid #39a84b;
  border-bottom: 3px solid #39a84b;
  transform: rotate(40deg);
  margin-top: -4px;
}
.ProfessionalViewMode_profile-view__dot__oc3Wh {
  width: 6px;
  height: 6px;
  margin-right: 8px;
  background-color: #82B194;
  border-radius: 50%;
  display: inline-block;
}

/* =========================================================
   CARD base
   ========================================================= */
.ProfessionalViewMode_card__MP7YX {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.05);
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}

.ProfessionalViewMode_passive-cover-card__3eLy4,
.ProfessionalViewMode_passive-identity-card__DH2Ao,
.ProfessionalViewMode_passive-copy-card__pb6Bw,
.ProfessionalViewMode_passive-studies-card__qU5oC,
.ProfessionalViewMode_passive-faq-card__KlOsI {
  padding: 28px 30px;
}

.ProfessionalViewMode_passive-cover-card__3eLy4 {
  display: grid;
  gap: 18px;
  padding: 0;
  overflow: hidden;
}

.ProfessionalViewMode_passive-cover-photo__XMGa0 {
  margin: 0 !important;
}

.ProfessionalViewMode_passive-cover-photo__XMGa0.ProfessionalViewMode_hero-preview__zsR6W {
  margin-bottom: 0;
  height: 292px;
  border-radius: 23px;
}

.ProfessionalViewMode_passive-identity-head__xxXCC {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.ProfessionalViewMode_passive-identity-name__Zyu6N {
  margin: 0;
  font-size: 44px;
  line-height: 0.98;
  letter-spacing: -0.04em;
  font-weight: 800;
  color: #13231D;
}

.ProfessionalViewMode_passive-identity-role__mKa7K {
  margin: 10px 0 0;
  font-size: 21px;
  line-height: 1.2;
  font-weight: 800;
  color: #65756E;
}

.ProfessionalViewMode_passive-share__G3gTj {
  font-size: 14px;
  font-weight: 700;
  color: var(--bw-text-muted);
  white-space: nowrap;
  padding-top: 8px;
  cursor: pointer;
}

.ProfessionalViewMode_passive-specialties__6o587 {
  display: grid;
  gap: 18px;
}

.ProfessionalViewMode_passive-specialties-row__uo9FV {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
}

.ProfessionalViewMode_passive-specialties-label__vjvUC {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #65756E;
  white-space: nowrap;
}

.ProfessionalViewMode_passive-specialties-icon__MXv7T {
  width: 20px;
  height: 20px;
  display: inline-block;
  object-fit: contain;
  opacity: 0.72;
}

.ProfessionalViewMode_passive-chip__lvq\\+0 {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(75, 88, 202, 0.45);
  font-size: 13px;
  font-weight: 700;
  color: #3f59b0;
  background: #f8f9fe;
}

.ProfessionalViewMode_passive-copy-card__pb6Bw h2,
.ProfessionalViewMode_passive-studies-card__qU5oC h2,
.ProfessionalViewMode_passive-faq-card__KlOsI h2 {
  margin: 0 0 12px;
  font-size: 26px;
  line-height: 1.1;
  font-weight: 800;
  color: #13231D;
}

.ProfessionalViewMode_passive-copy-card__pb6Bw p,
.ProfessionalViewMode_passive-copy-card__pb6Bw div > p,
.ProfessionalViewMode_passive-copy-card__pb6Bw div {
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.8;
  color: rgba(19, 35, 29, 0.68);
}

.ProfessionalViewMode_passive-implementation-note__gJWeP {
  display: flex;
  align-items: baseline;
  gap: 8px 12px;
  flex-wrap: wrap;
  margin: 0 2px -2px;
  padding: 0 2px;
  color: rgba(19, 35, 29, 0.68);
  font-size: 11px;
  line-height: 1.45;
}

.ProfessionalViewMode_passive-implementation-note__gJWeP strong {
  color: #5E806C;
  font-size: 11px;
  font-weight: 800;
}

.ProfessionalViewMode_passive-implementation-note__gJWeP span {
  font-weight: 500;
}

.ProfessionalViewMode_pricing-reference-group__3an6t {
  display: grid;
  gap: 7px;
  margin-top: 24px;
}

.ProfessionalViewMode_pricing-reference-caption__QydAu {
  min-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
  color: rgba(19, 35, 29, 0.68);
  font-size: 10.5px;
  line-height: 1.3;
}

.ProfessionalViewMode_pricing-reference-caption-spaced__Kw3zs {
  margin-top: 4px;
}

.ProfessionalViewMode_pricing-reference-caption__QydAu strong {
  font-size: 11.5px;
  font-weight: 750;
  color: #13231D;
}

.ProfessionalViewMode_pricing-reference-kicker__Y0LB6 {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.1);
  color: #5E806C;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.ProfessionalViewMode_passive-pricing-card__YgQhh {
  padding: 0;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.ProfessionalViewMode_passive-pricing-label__xo2Hh,
.ProfessionalViewMode_passive-pricing-metric-label__RUcHw {
  display: block;
  font-size: 8.5px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  color: #6E897C;
  font-weight: 800;
}

.ProfessionalViewMode_passive-pricing-metric-value__SeRpZ {
  margin-top: 7px;
  font-size: 15px;
  line-height: 1.15;
  color: #13231D;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ProfessionalViewMode_passive-pricing-modality-text__gp-4W {
  color: #3F574C;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
  white-space: nowrap;
}

.ProfessionalViewMode_passive-pricing-modality-text__gp-4W .ProfessionalViewMode_separator__cNaEP {
  color: #9AA9A2;
  font-weight: 500;
}

/* Variante A */
.ProfessionalViewMode_passive-pricing-single__zQNPV {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0;
}

.ProfessionalViewMode_passive-pricing-single-metric__E-XiC {
  position: relative;
  min-width: 0;
  padding: 14px 16px 15px;
}

.ProfessionalViewMode_passive-pricing-single-metric__E-XiC + .ProfessionalViewMode_passive-pricing-single-metric__E-XiC::before {
  content: "";
  position: absolute;
  left: 0;
  top: 14px;
  bottom: 14px;
  width: 1px;
  background: rgba(19, 35, 29, 0.08);
}

.ProfessionalViewMode_passive-pricing-single-metric--modality__-uWOR .ProfessionalViewMode_passive-pricing-metric-value__SeRpZ {
  color: #3F574C;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
}

/* Variante B */
.ProfessionalViewMode_passive-pricing-split__03\\+Xk {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0;
}

.ProfessionalViewMode_passive-pricing-type__zrSkb {
  position: relative;
  min-width: 0;
  padding: 14px 16px 15px;
}

.ProfessionalViewMode_passive-pricing-type__zrSkb + .ProfessionalViewMode_passive-pricing-type__zrSkb::before {
  content: "";
  position: absolute;
  left: 0;
  top: 14px;
  bottom: 14px;
  width: 1px;
  background: rgba(19, 35, 29, 0.08);
}

.ProfessionalViewMode_passive-pricing-type-inner__wdJ7I {
  display: grid;
  gap: 12px;
}

.ProfessionalViewMode_passive-pricing-type-copy__Y4yd6 {
  min-height: 34px;
}

.ProfessionalViewMode_passive-pricing-type-copy__Y4yd6 h4 {
  margin: 0 0 3px;
  font-size: 13.5px;
  line-height: 1.18;
  letter-spacing: -0.01em;
  font-weight: 800;
  color: #13231D;
}

.ProfessionalViewMode_passive-pricing-type-copy__Y4yd6 p {
  margin: 0;
  max-width: 300px;
  font-size: 9.5px;
  line-height: 1.3;
  color: rgba(19, 35, 29, 0.68);
}

.ProfessionalViewMode_passive-pricing-type-metrics__rBQS9 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.ProfessionalViewMode_passive-pricing-type-metric__cBNNg {
  min-width: 0;
}

.ProfessionalViewMode_passive-pricing-type-metric__cBNNg + .ProfessionalViewMode_passive-pricing-type-metric__cBNNg {
  padding-left: 18px;
  border-left: 1px solid rgba(19, 35, 29, 0.07);
}

.ProfessionalViewMode_passive-pricing-shared-modalities__eqWGf {
  position: relative;
  grid-column: 1/-1;
  padding: 11px 16px 13px;
}

.ProfessionalViewMode_passive-pricing-shared-modalities__eqWGf::before {
  content: "";
  position: absolute;
  left: 16px;
  right: 16px;
  top: 0;
  height: 1px;
  background: rgba(19, 35, 29, 0.08);
}

.ProfessionalViewMode_passive-pricing-shared-head__Puudc {
  display: block;
}

.ProfessionalViewMode_passive-pricing-shared-head__Puudc .ProfessionalViewMode_passive-pricing-modality-text__gp-4W {
  display: block;
  margin-top: 7px;
  color: #3F574C;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .ProfessionalViewMode_passive-identity-head__xxXCC {
    flex-direction: column;
  }
  .ProfessionalViewMode_passive-identity-name__Zyu6N {
    font-size: 44px;
  }
  .ProfessionalViewMode_passive-cover-photo__XMGa0.ProfessionalViewMode_hero-preview__zsR6W {
    height: 240px;
  }
  .ProfessionalViewMode_passive-pricing-single__zQNPV {
    grid-template-columns: 1fr 1fr;
  }
  .ProfessionalViewMode_passive-pricing-single-metric--modality__-uWOR {
    grid-column: 1/-1;
  }
  .ProfessionalViewMode_passive-pricing-single-metric--modality__-uWOR::before {
    left: 16px;
    right: 16px;
    top: 0;
    bottom: auto;
    width: auto;
    height: 1px;
  }
  .ProfessionalViewMode_passive-pricing-split__03\\+Xk {
    grid-template-columns: 1fr;
  }
  .ProfessionalViewMode_passive-pricing-type__zrSkb + .ProfessionalViewMode_passive-pricing-type__zrSkb::before {
    left: 16px;
    right: 16px;
    top: 0;
    bottom: auto;
    width: auto;
    height: 1px;
  }
  .ProfessionalViewMode_passive-pricing-type-copy__Y4yd6 {
    min-height: 0;
  }
}
@media (max-width: 640px) {
  .ProfessionalViewMode_passive-pricing-single__zQNPV {
    grid-template-columns: 1fr;
  }
  .ProfessionalViewMode_passive-pricing-single-metric__E-XiC + .ProfessionalViewMode_passive-pricing-single-metric__E-XiC::before {
    left: 16px;
    right: 16px;
    top: 0;
    bottom: auto;
    width: auto;
    height: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/EditProfileProfessional/components/ViewMode/ProfessionalViewMode.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AARA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,+BAAA;AAWJ;AATI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAWR;AATQ;EANJ;IAOQ,QAAA;EAYV;AACF;AATI;EACI,SAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cDPe;ACkBvB;AATQ;EARJ;IASQ,eAAA;EAYV;AACF;AATI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BDhBe;AC2BvB;AATQ;EANJ;IAOQ,eAAA;EAYV;AACF;AATI;EACI,eAAA;EACA,cD1Be;EC2Bf,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAWR;AATQ;EACI,cDrCW;ACgDvB;AAPI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AASR;AANI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BDrDe;AC6DvB;AALI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAOR;AAJI;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAMR;AAHI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,uCAAA;EACA,mBDnFe;ECoFf,eAAA;EACA,gBAAA;AAKR;AAHQ;EACI,kCAAA;EACA,cAAA;EACA,yBAAA;AAKZ;AAFQ;EACI,kCAAA;EACA,cAAA;EACA,yBAAA;AAIZ;AADQ;EACI,oCAAA;EACA,cAAA;EACA,yBAAA;AAGZ;AAAQ;EACI,oCAAA;EACA,cAAA;EACA,yBAAA;AAEZ;AAGI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,6BDvHe;ECwHf,gBAAA;AAFR;AAKI;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAHR;AAKQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,+BAAA;EACA,gCAAA;EACA,wBAAA;EACA,gBAAA;AAHZ;AAOI;EACI,UAAA;EACA,WAAA;EACA,iBAAA;EACA,yBDnKe;ECoKf,kBAAA;EACA,qBAAA;AALR;;AAaA;;8DAAA;AAGA;EACI,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,2CAAA;AAVJ;;AAaA;;;;;EAKI,kBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,oBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,SAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAVJ;;AAaA;EACI,aAAA;EACA,SAAA;AAVJ;;AAaA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;AAVJ;;AAaA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAVJ;;AAaA;;;EAGI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;;AAaA;;;EAGI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAVJ;;AAaA;EACI,aAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,QAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;AAVJ;;AAaA;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,UAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AAVJ;;AAaA;;EAEI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,cAAA;EACA,gBAAA;AAVJ;;AAaA,eAAA;AACA;EACI,aAAA;EACA,gDAAA;EACA,UAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,YAAA;EACA,uBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,kCAAA;AAVJ;;AAaA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAVJ;;AAaA,eAAA;AACA;EACI,aAAA;EACA,gDAAA;EACA,UAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,YAAA;EACA,uBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,kCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,SAAA;AAVJ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AAVJ;;AAaA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;AAVJ;;AAaA;EACI,YAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,6CAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,iBAAA;EACA,uBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,kCAAA;AAVJ;;AAaA;EACI,cAAA;AAVJ;;AAaA;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI;IACI,sBAAA;EAVN;EAaE;IACI,eAAA;EAXN;EAcE;IACI,aAAA;EAZN;EAeE;IACI,8BAAA;EAbN;EAgBE;IACI,iBAAA;EAdN;EAiBE;IACI,UAAA;IACA,WAAA;IACA,MAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;EAfN;EAkBE;IACI,0BAAA;EAhBN;EAmBE;IACI,UAAA;IACA,WAAA;IACA,MAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;EAjBN;EAoBE;IACI,aAAA;EAlBN;AACF;AAqBA;EACI;IACI,0BAAA;EAnBN;EAsBE;IACI,UAAA;IACA,WAAA;IACA,MAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;EApBN;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../../assets/styles/variables';\n\n$bw-text: $text-main;\n$bw-muted: $text-muted;\n$bw-muted-solid: $text-secondary;\n$bw-primary: $color-primary;\n$bw-surface-2: $color-surface-soft;\n\n.profile-view {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    font-family: \"Sora\", sans-serif;\n\n    &__head {\n        display: flex;\n        justify-content: space-between;\n        gap: 16px;\n        align-items: start;\n\n        @media (max-width: 600px) {\n            gap: 5px;\n        }\n    }\n\n    &__name {\n        margin: 0;\n        font-size: 44px;\n        line-height: 0.98;\n        letter-spacing: -0.04em;\n        font-weight: 800;\n        color: $bw-text;\n\n        @media (max-width: 768px) {\n            font-size: 32px;\n        }\n    }\n\n    &__role {\n        margin: 10px 0 0;\n        font-size: 21px;\n        font-weight: 800;\n        color: $bw-muted-solid;\n\n        @media (max-width: 768px) {\n            font-size: 18px;\n        }\n    }\n\n    &__share {\n        font-size: 12px;\n        color: $bw-muted;\n        font-weight: 700;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        white-space: nowrap;\n        cursor: pointer;\n        padding-top: 8px;\n\n        &:hover {\n            color: $bw-text;\n        }\n    }\n\n    &__specialties {\n        margin-top: 18px;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 12px;\n    }\n\n    &__label {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        font-size: 14px;\n        font-weight: 700;\n        color: $bw-muted-solid;\n    }\n\n    &__icon-tag {\n        width: 20px;\n        height: 20px;\n        object-fit: contain;\n        opacity: 0.72;\n    }\n\n    &__chip-row {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n    }\n\n    &__tag {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-height: 30px;\n        padding: 0 11px;\n        border-radius: 999px;\n        border: 1px solid rgba(16, 25, 21, 0.1);\n        background: $bw-surface-2;\n        font-size: 11px;\n        font-weight: 800;\n\n        &--cuerpo {\n            background: rgba(36, 46, 123, 0.10);\n            color: #242E7B;\n            border: 1px solid #242E7B;\n        }\n\n        &--conciencia {\n            background: rgba(87, 64, 147, 0.10);\n            color: #574093;\n            border: 1px solid #574093;\n        }\n\n        &--mente {\n            background: rgba(93, 138, 186, 0.12);\n            color: #4F769F;\n            border: 1px solid #4F769F;\n        }\n\n        &--energia {\n            background: rgba(83, 169, 110, 0.12);\n            color: #3F8355;\n            border: 1px solid #3F8355;\n        }\n\n    }\n\n    &__meta-group {\n        margin-top: 20px;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    &__meta-line {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 14px;\n        color: $bw-muted-solid;\n        font-weight: 700;\n    }\n\n    &__icon-check {\n        width: 14px;\n        height: 14px;\n        display: inline-block;\n        position: relative;\n        flex: 0 0 auto;\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            left: 1px;\n            top: 3px;\n            width: 5px;\n            height: 9px;\n            border-right: 3px solid #39a84b;\n            border-bottom: 3px solid #39a84b;\n            transform: rotate(40deg);\n            margin-top: -4px;\n        }\n    }\n\n    &__dot {\n        width: 6px;\n        height: 6px;\n        margin-right: 8px;\n        background-color: $bw-primary;\n        border-radius: 50%;\n        display: inline-block;\n    }\n}\n\n\n\n\n\n/* =========================================================\n   CARD base\n   ========================================================= */\n.card {\n    background: #F7F5F1;\n    border: 1px solid rgba(16, 25, 21, 0.05);\n    border-radius: 24px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);\n}\n\n.passive-cover-card,\n.passive-identity-card,\n.passive-copy-card,\n.passive-studies-card,\n.passive-faq-card {\n    padding: 28px 30px;\n}\n\n.passive-cover-card {\n    display: grid;\n    gap: 18px;\n    padding: 0;\n    overflow: hidden;\n}\n\n.passive-cover-photo {\n    margin: 0 !important;\n}\n\n.passive-cover-photo.hero-preview {\n    margin-bottom: 0;\n    height: 292px;\n    border-radius: 23px;\n}\n\n.passive-identity-head {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    align-items: flex-start;\n    margin-bottom: 16px;\n}\n\n.passive-identity-name {\n    margin: 0;\n    font-size: 44px;\n    line-height: .98;\n    letter-spacing: -.04em;\n    font-weight: 800;\n    color: #13231D;\n}\n\n.passive-identity-role {\n    margin: 10px 0 0;\n    font-size: 21px;\n    line-height: 1.2;\n    font-weight: 800;\n    color: #65756E;\n}\n\n.passive-share {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--bw-text-muted);\n    white-space: nowrap;\n    padding-top: 8px;\n    cursor: pointer;\n}\n\n.passive-specialties {\n    display: grid;\n    gap: 18px;\n}\n\n.passive-specialties-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px 12px;\n}\n\n.passive-specialties-label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #65756E;\n    white-space: nowrap;\n}\n\n.passive-specialties-icon {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    object-fit: contain;\n    opacity: .72;\n}\n\n.passive-chip {\n    display: inline-flex;\n    align-items: center;\n    min-height: 30px;\n    padding: 0 14px;\n    border-radius: 999px;\n    border: 1px solid rgba(75, 88, 202, .45);\n    font-size: 13px;\n    font-weight: 700;\n    color: #3f59b0;\n    background: #f8f9fe;\n}\n\n.passive-copy-card h2,\n.passive-studies-card h2,\n.passive-faq-card h2 {\n    margin: 0 0 12px;\n    font-size: 26px;\n    line-height: 1.1;\n    font-weight: 800;\n    color: #13231D;\n}\n\n.passive-copy-card p,\n.passive-copy-card div>p,\n.passive-copy-card div {\n    margin: 0 0 14px;\n    font-size: 15px;\n    line-height: 1.8;\n    color: rgba(19, 35, 29, 0.68);\n}\n\n.passive-implementation-note {\n    display: flex;\n    align-items: baseline;\n    gap: 8px 12px;\n    flex-wrap: wrap;\n    margin: 0 2px -2px;\n    padding: 0 2px;\n    color: rgba(19, 35, 29, 0.68);\n    font-size: 11px;\n    line-height: 1.45;\n}\n\n.passive-implementation-note strong {\n    color: #5E806C;\n    font-size: 11px;\n    font-weight: 800;\n}\n\n.passive-implementation-note span {\n    font-weight: 500;\n}\n\n.pricing-reference-group {\n    display: grid;\n    gap: 7px;\n    margin-top: 24px;\n}\n\n.pricing-reference-caption {\n    min-height: 20px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 0 4px;\n    color: rgba(19, 35, 29, 0.68);\n    font-size: 10.5px;\n    line-height: 1.3;\n}\n\n.pricing-reference-caption-spaced {\n    margin-top: 4px;\n}\n\n.pricing-reference-caption strong {\n    font-size: 11.5px;\n    font-weight: 750;\n    color: #13231D;\n}\n\n.pricing-reference-kicker {\n    display: inline-flex;\n    align-items: center;\n    min-height: 20px;\n    padding: 0 8px;\n    border-radius: 999px;\n    background: rgba(130, 177, 148, .10);\n    color: #5E806C;\n    font-size: 8px;\n    font-weight: 800;\n    letter-spacing: .09em;\n    text-transform: uppercase;\n}\n\n.passive-pricing-card {\n    padding: 0;\n    border-radius: 18px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);\n    overflow: hidden;\n}\n\n.passive-pricing-label,\n.passive-pricing-metric-label {\n    display: block;\n    font-size: 8.5px;\n    line-height: 1;\n    text-transform: uppercase;\n    letter-spacing: .11em;\n    color: #6E897C;\n    font-weight: 800;\n}\n\n.passive-pricing-metric-value {\n    margin-top: 7px;\n    font-size: 15px;\n    line-height: 1.15;\n    color: #13231D;\n    font-weight: 800;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n}\n\n.passive-pricing-modality-text {\n    color: #3F574C;\n    font-size: 12px;\n    line-height: 1.2;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.passive-pricing-modality-text .separator {\n    color: #9AA9A2;\n    font-weight: 500;\n}\n\n/* Variante A */\n.passive-pricing-single {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    padding: 0;\n}\n\n.passive-pricing-single-metric {\n    position: relative;\n    min-width: 0;\n    padding: 14px 16px 15px;\n}\n\n.passive-pricing-single-metric+.passive-pricing-single-metric::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 14px;\n    bottom: 14px;\n    width: 1px;\n    background: rgba(19, 35, 29, .08);\n}\n\n.passive-pricing-single-metric--modality .passive-pricing-metric-value {\n    color: #3F574C;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0;\n}\n\n/* Variante B */\n.passive-pricing-split {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    padding: 0;\n}\n\n.passive-pricing-type {\n    position: relative;\n    min-width: 0;\n    padding: 14px 16px 15px;\n}\n\n.passive-pricing-type+.passive-pricing-type::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 14px;\n    bottom: 14px;\n    width: 1px;\n    background: rgba(19, 35, 29, .08);\n}\n\n.passive-pricing-type-inner {\n    display: grid;\n    gap: 12px;\n}\n\n.passive-pricing-type-copy {\n    min-height: 34px;\n}\n\n.passive-pricing-type-copy h4 {\n    margin: 0 0 3px;\n    font-size: 13.5px;\n    line-height: 1.18;\n    letter-spacing: -.01em;\n    font-weight: 800;\n    color: #13231D;\n}\n\n.passive-pricing-type-copy p {\n    margin: 0;\n    max-width: 300px;\n    font-size: 9.5px;\n    line-height: 1.3;\n    color: rgba(19, 35, 29, 0.68);\n}\n\n.passive-pricing-type-metrics {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 18px;\n}\n\n.passive-pricing-type-metric {\n    min-width: 0;\n}\n\n.passive-pricing-type-metric+.passive-pricing-type-metric {\n    padding-left: 18px;\n    border-left: 1px solid rgba(19, 35, 29, .07);\n}\n\n.passive-pricing-shared-modalities {\n    position: relative;\n    grid-column: 1 / -1;\n    padding: 11px 16px 13px;\n}\n\n.passive-pricing-shared-modalities::before {\n    content: '';\n    position: absolute;\n    left: 16px;\n    right: 16px;\n    top: 0;\n    height: 1px;\n    background: rgba(19, 35, 29, .08);\n}\n\n.passive-pricing-shared-head {\n    display: block;\n}\n\n.passive-pricing-shared-head .passive-pricing-modality-text {\n    display: block;\n    margin-top: 7px;\n    color: #3F574C;\n    font-size: 12px;\n    line-height: 1.2;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n@media(max-width:1100px) {\n    .passive-identity-head {\n        flex-direction: column;\n    }\n\n    .passive-identity-name {\n        font-size: 44px;\n    }\n\n    .passive-cover-photo.hero-preview {\n        height: 240px;\n    }\n\n    .passive-pricing-single {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .passive-pricing-single-metric--modality {\n        grid-column: 1 / -1;\n    }\n\n    .passive-pricing-single-metric--modality::before {\n        left: 16px;\n        right: 16px;\n        top: 0;\n        bottom: auto;\n        width: auto;\n        height: 1px;\n    }\n\n    .passive-pricing-split {\n        grid-template-columns: 1fr;\n    }\n\n    .passive-pricing-type+.passive-pricing-type::before {\n        left: 16px;\n        right: 16px;\n        top: 0;\n        bottom: auto;\n        width: auto;\n        height: 1px;\n    }\n\n    .passive-pricing-type-copy {\n        min-height: 0;\n    }\n}\n\n@media(max-width:640px) {\n    .passive-pricing-single {\n        grid-template-columns: 1fr;\n    }\n\n    .passive-pricing-single-metric+.passive-pricing-single-metric::before {\n        left: 16px;\n        right: 16px;\n        top: 0;\n        bottom: auto;\n        width: auto;\n        height: 1px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-view": `ProfessionalViewMode_profile-view__KPgLe`,
	"profile-view__head": `ProfessionalViewMode_profile-view__head__XALgF`,
	"profile-view__name": `ProfessionalViewMode_profile-view__name__gkn3m`,
	"profile-view__role": `ProfessionalViewMode_profile-view__role__mpOD7`,
	"profile-view__share": `ProfessionalViewMode_profile-view__share__tAJZX`,
	"profile-view__specialties": `ProfessionalViewMode_profile-view__specialties__JaRW3`,
	"profile-view__label": `ProfessionalViewMode_profile-view__label__q6qV8`,
	"profile-view__icon-tag": `ProfessionalViewMode_profile-view__icon-tag__YH6dC`,
	"profile-view__chip-row": `ProfessionalViewMode_profile-view__chip-row__wfSC1`,
	"profile-view__tag": `ProfessionalViewMode_profile-view__tag__fdcar`,
	"profile-view__tag--cuerpo": `ProfessionalViewMode_profile-view__tag--cuerpo__wJppv`,
	"profile-view__tag--conciencia": `ProfessionalViewMode_profile-view__tag--conciencia__CJzxq`,
	"profile-view__tag--mente": `ProfessionalViewMode_profile-view__tag--mente__o246A`,
	"profile-view__tag--energia": `ProfessionalViewMode_profile-view__tag--energia__kj3F+`,
	"profile-view__meta-group": `ProfessionalViewMode_profile-view__meta-group__B-JXG`,
	"profile-view__meta-line": `ProfessionalViewMode_profile-view__meta-line__j1bgk`,
	"profile-view__icon-check": `ProfessionalViewMode_profile-view__icon-check__wQnen`,
	"profile-view__dot": `ProfessionalViewMode_profile-view__dot__oc3Wh`,
	"card": `ProfessionalViewMode_card__MP7YX`,
	"passive-cover-card": `ProfessionalViewMode_passive-cover-card__3eLy4`,
	"passive-identity-card": `ProfessionalViewMode_passive-identity-card__DH2Ao`,
	"passive-copy-card": `ProfessionalViewMode_passive-copy-card__pb6Bw`,
	"passive-studies-card": `ProfessionalViewMode_passive-studies-card__qU5oC`,
	"passive-faq-card": `ProfessionalViewMode_passive-faq-card__KlOsI`,
	"passive-cover-photo": `ProfessionalViewMode_passive-cover-photo__XMGa0`,
	"hero-preview": `ProfessionalViewMode_hero-preview__zsR6W`,
	"passive-identity-head": `ProfessionalViewMode_passive-identity-head__xxXCC`,
	"passive-identity-name": `ProfessionalViewMode_passive-identity-name__Zyu6N`,
	"passive-identity-role": `ProfessionalViewMode_passive-identity-role__mKa7K`,
	"passive-share": `ProfessionalViewMode_passive-share__G3gTj`,
	"passive-specialties": `ProfessionalViewMode_passive-specialties__6o587`,
	"passive-specialties-row": `ProfessionalViewMode_passive-specialties-row__uo9FV`,
	"passive-specialties-label": `ProfessionalViewMode_passive-specialties-label__vjvUC`,
	"passive-specialties-icon": `ProfessionalViewMode_passive-specialties-icon__MXv7T`,
	"passive-chip": `ProfessionalViewMode_passive-chip__lvq+0`,
	"passive-implementation-note": `ProfessionalViewMode_passive-implementation-note__gJWeP`,
	"pricing-reference-group": `ProfessionalViewMode_pricing-reference-group__3an6t`,
	"pricing-reference-caption": `ProfessionalViewMode_pricing-reference-caption__QydAu`,
	"pricing-reference-caption-spaced": `ProfessionalViewMode_pricing-reference-caption-spaced__Kw3zs`,
	"pricing-reference-kicker": `ProfessionalViewMode_pricing-reference-kicker__Y0LB6`,
	"passive-pricing-card": `ProfessionalViewMode_passive-pricing-card__YgQhh`,
	"passive-pricing-label": `ProfessionalViewMode_passive-pricing-label__xo2Hh`,
	"passive-pricing-metric-label": `ProfessionalViewMode_passive-pricing-metric-label__RUcHw`,
	"passive-pricing-metric-value": `ProfessionalViewMode_passive-pricing-metric-value__SeRpZ`,
	"passive-pricing-modality-text": `ProfessionalViewMode_passive-pricing-modality-text__gp-4W`,
	"separator": `ProfessionalViewMode_separator__cNaEP`,
	"passive-pricing-single": `ProfessionalViewMode_passive-pricing-single__zQNPV`,
	"passive-pricing-single-metric": `ProfessionalViewMode_passive-pricing-single-metric__E-XiC`,
	"passive-pricing-single-metric--modality": `ProfessionalViewMode_passive-pricing-single-metric--modality__-uWOR`,
	"passive-pricing-split": `ProfessionalViewMode_passive-pricing-split__03+Xk`,
	"passive-pricing-type": `ProfessionalViewMode_passive-pricing-type__zrSkb`,
	"passive-pricing-type-inner": `ProfessionalViewMode_passive-pricing-type-inner__wdJ7I`,
	"passive-pricing-type-copy": `ProfessionalViewMode_passive-pricing-type-copy__Y4yd6`,
	"passive-pricing-type-metrics": `ProfessionalViewMode_passive-pricing-type-metrics__rBQS9`,
	"passive-pricing-type-metric": `ProfessionalViewMode_passive-pricing-type-metric__cBNNg`,
	"passive-pricing-shared-modalities": `ProfessionalViewMode_passive-pricing-shared-modalities__eqWGf`,
	"passive-pricing-shared-head": `ProfessionalViewMode_passive-pricing-shared-head__Puudc`
};
export default ___CSS_LOADER_EXPORT___;
